/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Editor_Resume_TitleInputs */

const en_resume_editor_resume_title = /** @type {(inputs: Resume_Editor_Resume_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume Title`)
};

const de_resume_editor_resume_title = /** @type {(inputs: Resume_Editor_Resume_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebenslauf-Titel`)
};

const fr_resume_editor_resume_title = /** @type {(inputs: Resume_Editor_Resume_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titre du CV`)
};

const es_resume_editor_resume_title = /** @type {(inputs: Resume_Editor_Resume_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titulo del curriculo`)
};

const it_resume_editor_resume_title = /** @type {(inputs: Resume_Editor_Resume_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titolo del CV`)
};

const nl_resume_editor_resume_title = /** @type {(inputs: Resume_Editor_Resume_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cv-titel`)
};

const pl_resume_editor_resume_title = /** @type {(inputs: Resume_Editor_Resume_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tytul CV`)
};

const fi_resume_editor_resume_title = /** @type {(inputs: Resume_Editor_Resume_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansioluettelon otsikko`)
};

const da_resume_editor_resume_title = /** @type {(inputs: Resume_Editor_Resume_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV-titel`)
};

const sv_resume_editor_resume_title = /** @type {(inputs: Resume_Editor_Resume_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV-titel`)
};

/**
* | output |
* | --- |
* | "Resume Title" |
*
* @param {Resume_Editor_Resume_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resume_editor_resume_title = /** @type {((inputs?: Resume_Editor_Resume_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Editor_Resume_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resume_editor_resume_title(inputs)
	if (locale === "fr") return fr_resume_editor_resume_title(inputs)
	if (locale === "es") return es_resume_editor_resume_title(inputs)
	if (locale === "it") return it_resume_editor_resume_title(inputs)
	if (locale === "nl") return nl_resume_editor_resume_title(inputs)
	if (locale === "pl") return pl_resume_editor_resume_title(inputs)
	if (locale === "fi") return fi_resume_editor_resume_title(inputs)
	if (locale === "da") return da_resume_editor_resume_title(inputs)
	if (locale === "sv") return sv_resume_editor_resume_title(inputs)
	return en_resume_editor_resume_title(inputs)
});